module.exports = __webpack_public_path__ + "img/environment7.e9e79317.png";